export default __webpack_public_path__ + "static/logo-range-homes-2aabb3f0cbdd7ae4df1c8b80891a2802.png";